(function () {
  const collapsibleDescription = () => {
    const collapsibleText = document.querySelector('.collapsible_text')
    const expandedBtn = document.querySelector('.collapsible_description_btn')

    expandedBtn.addEventListener('click', ()=> {
        collapsibleText.classList.toggle('expanded')
    })
  };

  document.addEventListener("DOMContentLoaded", collapsibleDescription);
  document.addEventListener("shopify:section:load", collapsibleDescription);
})();
